import { FC } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { CbAvatar } from '../CbAvatar';
export interface CbUserProps {
  fontSize?: string;
  getInitials?: (name: string) => string;
  imageUrl?: string;
  isDarkMode?: boolean;
  name: string;
  isHexagon?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  badgeUrl?: string;
  hideName?: boolean;
  placement?: number;
  color?: string;
  link?: string;
}
export const CbUser: FC<CbUserProps> = ({
  fontSize = 'sm',
  getInitials,
  imageUrl,
  isDarkMode,
  name,
  size = 'xs',
  badgeUrl,
  hideName = false,
  color,
  link
}) => {
  const textColor = color || (isDarkMode ? 'text.primaryWhite' : 'text.primary');
  return <Flex alignItems="center" justifyContent="flex-start" data-sentry-element="Flex" data-sentry-component="CbUser" data-sentry-source-file="CbUser.tsx">
      <CbAvatar borderColor="transparent" borderWidth="0" getInitials={getInitials} image={imageUrl} name={name} avatarSize={size} badgeUrl={badgeUrl} data-sentry-element="CbAvatar" data-sentry-source-file="CbUser.tsx" />
      {!hideName && link ? <NextLink href={link} passHref>
          <Text as="a" color={textColor} fontSize={fontSize} marginLeft={2} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" _hover={{
        textDecoration: 'underline'
      }}>
            {name}
          </Text>
        </NextLink> : !hideName && <Text color={textColor} fontSize={fontSize} marginLeft={2} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
            {name}
          </Text>}
    </Flex>;
};